import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ChangePasswordModalComponent} from './change-password-modal.component';
import {SharedModule} from '../../../modules/shared/shared.module';
import {FormModule} from '../../../modules/form/form.module';
import {DynamicDialogModule} from 'primeng/dynamicdialog';

@NgModule({
  declarations: [
    ChangePasswordModalComponent
  ],
  imports: [
    CommonModule,
    DynamicDialogModule,
    FormModule,
    SharedModule
  ]
})
export class ChangePasswordModalModule {
}
